{
  "name": "gloomhavensecretariat",
  "version": "0.173.2",
  "license": "AGPL3",
  "description": "Gloomhaven Secretariat is a Gloomhaven/Frosthaven Companion app.",
  "homepage": "https://gloomhaven-secretariat.de",
  "author": {
    "name": "Lurkars",
    "email": "contact@gloomhaven-secretariat.de",
    "url": "https://www.champonthis.de"
  },
  "repository": "github:Lurkars/gloomhavensecretariat",
  "bugs": "https://github.com/Lurkars/gloomhavensecretariat/issues",
  "funding": {
    "type": "ko-fi",
    "url": "https://ko-fi.com/lurkars"
  },
  "main": "main.js",
  "engines": {
    "node": ">=24"
  },
  "nodemonConfig": {
    "execMap": {
      "js": "node ./scripts/build-data.js"
    },
    "watch": [
      "data/"
    ],
    "ext": "json",
    "runOnChangeOnly": true
  },
  "scripts": {
    "prepare": "husky",
    "prestart": "node ./scripts/build-data.js",
    "start": "ng serve",
    "prebuild": "node ./scripts/build-data.js && node ./scripts/pre-build.js",
    "build": "ng build",
    "postbuild": "node ./scripts/post-build.js",
    "pretest": "node ./scripts/build-data.js",
    "test": "ng test",
    "lint": "eslint \"src/**/*.{ts,html}\"",
    "lint:fix": "eslint \"src/**/*.{ts,html}\" --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss}\"",
    "watch": "nodemon",
    "electron": "npm run build -- --configuration production,electron --base-href ./ && electron . --no-sandbox",
    "electron:build": "npm run build -- --configuration production,electron --base-href ./ && electron-builder",
    "electron:build:linux:appimage": "npm run build -- --configuration production,electron --base-href ./ && electron-builder --linux AppImage",
    "patch-android": "node ./scripts/patch-android.js"
  },
  "build": {
    "appId": "gloomhavensecretariat",
    "publish": [
      {
        "provider": "github",
        "owner": "Lurkars",
        "repo": "gloomhavensecretariat"
      }
    ],
    "linux": {
      "target": [
        "AppImage",
        "rpm",
        "deb"
      ]
    },
    "mac": {
      "type": "distribution",
      "target": [
        {
          "target": "dmg",
          "arch": [
            "universal"
          ]
        },
        {
          "target": "pkg",
          "arch": [
            "universal"
          ]
        }
      ]
    },
    "win": {
      "target": "nsis",
      "icon": "build/icon.ico"
    },
    "files": [
      "main.js",
      "dist/gloomhavensecretariat"
    ]
  },
  "private": true,
  "overrides": {
    "@babel/core": "8.0.1",
    "esbuild": "0.28.1"
  },
  "dependencies": {
    "@angular/cdk": "~22.2.4",
    "@angular/common": "~22.2.3",
    "@angular/compiler": "~22.2.3",
    "@angular/core": "~22.2.3",
    "@angular/forms": "~22.2.3",
    "@angular/platform-browser": "~22.2.3",
    "@angular/router": "~22.2.3",
    "@angular/service-worker": "~22.2.3",
    "@capacitor/app": "^8.1.2",
    "@capacitor/core": "^8.5.3",
    "autocompleter": "^10.0.0",
    "electron-updater": "^6.8.12",
    "leaflet": "^1.9.4",
    "mermaid": "^12.2.0",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular-eslint/schematics": "^22.6.0",
    "@angular/build": "^22.2.4",
    "@angular/cli": "~22.2.4",
    "@angular/compiler-cli": "~22.2.3",
    "@capacitor/android": "^8.5.3",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.5.3",
    "@capacitor/ios": "^8.5.3",
    "@types/dom-screen-wake-lock": "1.0.3",
    "@types/leaflet": "^1.9.22",
    "angular-eslint": "^22.6.0",
    "browserslist": "^4.29.5",
    "electron": "^44.10.0",
    "electron-builder": "^26.18.1",
    "eslint": "^10.13.0",
    "eslint-config-prettier": "^10.1.8",
    "http-server": "^14.1.1",
    "husky": "^9.1.7",
    "jsdom": "^30.1.3",
    "lint-staged": "^17.6.0",
    "nodemon": "^3.1.14",
    "prettier": "^3.9.10",
    "prettier-plugin-organize-imports": "^4.3.0",
    "tsx": "^4.23.15",
    "typescript": "~6.0.3",
    "vitest": "^5.0.5"
  },
  "lint-staged": {
    "src/**/*.{ts,html}": [
      "eslint --fix",
      "prettier --write"
    ],
    "src/**/*.scss": [
      "prettier --write"
    ]
  },
  "allowScripts": {
    "electron-winstaller@5.4.0": true,
    "esbuild@0.28.1": true,
    "msgpackr-extract@3.0.4": true,
    "sharp@0.32.6": true,
    "@parcel/watcher@2.6.0": true,
    "lmdb@3.5.6": true
  }
}